import { Location, LocationType } from '../SearchLocation.types'
import { defaultSearchConfig } from './searchConfig'

/**
 * Format a location type for display
 * @param type - Location type to format
 * @param labels - Custom label mappings (optional)
 * @returns Formatted display string
 */
export const formatLocationType = (
  type: LocationType,
  labels?: Record<LocationType, string>
): string => {
  const labelMap = labels || defaultSearchConfig.typeLabels
  return labelMap[type] || type
}

/**
 * Get color for a location type tag
 * @param type - Location type
 * @param colors - Custom color mappings (optional)
 * @returns Color hex string
 */
export const getLocationTypeColor = (
  type: LocationType,
  colors?: Record<LocationType, string>
): string => {
  const colorMap = colors || defaultSearchConfig.typeColors
  return colorMap[type] || '#6b7280'
}

/**
 * Format location for display (e.g., in input field)
 * @param location - Location object
 * @returns Formatted display string
 */
export const formatLocationDisplay = (location: Location): string => {
  return location.location_search
}

/**
 * Create a unique key for a location item
 * @param location - Location object
 * @returns Unique key string
 */
export const getLocationKey = (location: Location): string => {
  return `${location.location_type}-${location.id}`
}
